import axios from 'axios';

const BASE_URL = process.env.VUE_APP_BASE_URL_ATOM;

export default axios.create({
    baseURL: BASE_URL,
    headers: {
        'Api-Key': process.env.VUE_APP_API_KEY_ATOM,
    },
});
